import uniqolor from "uniqolor"
import { Line } from "react-chartjs-2"
import React from "react"
import { Grid2, Typography } from "@mui/material"
import { getGraphStyles } from "routes/sfg20-admin/plugins/system-info/activity-tab/graphs/graph-styles"

export function AnalysisTimeSeriesGraph({ data, label, title, granularity, options = {} }) {
    const { size, graphGridSx } = getGraphStyles(options)

    const cleanedData = data
        .map((d) => {
            const date = new Date(d.x)
            return {
                ...d,
                x: date.toISOString(),
                y: d.y,
            }
        })
        .sort((a, b) => new Date(a.x) - new Date(b.x))

    const timeFormatting = {
        unit: granularity,
        displayFormats: {
            hour: "MMM d, HH:mm",
            day: "MMM d, yyyy",
            month: "MMM yyyy",
        },
    }

    return (
        <Grid2 size={size} sx={graphGridSx}>
            <Line
                data={{
                    datasets: [
                        {
                            label,
                            data: cleanedData,
                            fill: true,
                            borderColor: uniqolor(label, {
                                saturation: [50, 75],
                                lightness: [20, 50],
                            }).color,
                            backgroundColor: uniqolor(label, {
                                saturation: [50, 75],
                                lightness: [60, 80],
                            }).color,
                            tension: 0.4,
                        },
                    ],
                }}
                options={{
                    scales: {
                        x: {
                            type: "time",
                            time: timeFormatting,
                            ticks: {
                                autoSkip: true,
                                maxTicksLimit: Math.min(data.length, 10),
                                maxRotation: 45,
                                minRotation: 45,
                            },
                        },
                        y: { beginAtZero: true },
                    },
                    plugins: {
                        legend: {
                            display: false, // hides labels completely
                        },
                    },
                }}
            />
            <Typography mt={2} variant="subtitle1" sx={{ width: "100%", textAlign: "center", marginBottom: 2 }}>
                {title}
            </Typography>
        </Grid2>
    )
}
